import FaqPage from './faq-page';
export default FaqPage;
